document.addEventListener("DOMContentLoaded", function () {
    const slidingCardSwipers = document.querySelectorAll('.slider-large .large-card-swiper');

    if(slidingCardSwipers.length > 0) {
        slidingCardSwipers.forEach((cardSwiper) => {
            const swiperId = cardSwiper.dataset.unique;

            const servicesSwiper = new Swiper(`.large-card-swiper[data-unique=${swiperId}]`, {
                // Optional parameters
                loop: true,
                initialSlide: 1,
                slidesPerView: 'auto',
                slidesPerViewAutoSlideSize: 500,
                spaceBetween: 100,
                autoplay: false,
                allowTouchMove: true, // Enable touch/swipe gestures
                speed: 800,
                navigation: {
                    nextEl: `.slider-large .swiper-controls[data-controls=${swiperId}] .next`,
                    prevEl: `.slider-large .swiper-controls[data-controls=${swiperId}] .prev`,
                },
            });
        });
    }
});